export const StoryGameMapping = {
    embedUrl: 'specific.storygame.embedUrl'
};
